import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type {
  PromoFlowSearchParams,
  TemplatesLibrary,
} from '../../components/templatesLibrary/types.ts';

interface PromoFlowState {
  templates: TemplatesLibrary[];
  loading: boolean;
  error: string | null;
  restaurantId: string | null;
  serviceType: string;
}

const initialState: PromoFlowState = {
  templates: [],
  loading: false,
  error: null,
  restaurantId: null,
  serviceType: 'promoflow',
};

const promoflowSlice = createSlice({
  name: 'templatesLibrary',
  initialState,

  reducers: {
    // Request
    fetchTemplatesLibraryRequest: (
      state,
      action: PayloadAction<PromoFlowSearchParams>
    ) => {
      state.loading = true;
      state.error = null;
      state.restaurantId = action.payload.restaurantId;
      state.serviceType = action.payload.serviceType || 'promoflow';
    },

    // Success
    fetchTemplatesLibrarySuccess: (
      state,
      action: PayloadAction<TemplatesLibrary[]>
    ) => {
      state.loading = false;
      state.templates = action.payload;
      state.error = null;
    },

    // Failure
    fetchTemplatesLibraryFailure: (
      state,
      action: PayloadAction<string>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Reset
    resetTemplatesLibrary: (state) => {
      state.templates = [];
      state.loading = false;
      state.error = null;
      state.restaurantId = null;
      state.serviceType = 'promoflow';
    },
  },
});

export const {
  fetchTemplatesLibraryRequest,
  fetchTemplatesLibrarySuccess,
  fetchTemplatesLibraryFailure,
  resetTemplatesLibrary,
} = promoflowSlice.actions;

export default promoflowSlice.reducer;